import i18n from "@swa-ui/locale";
import { yup } from "@swa-ui/object";

export const fieldMaxLengths = {
  passcode: 6,
};

export const fieldMinLengths = {
  passcode: 6,
};

export const getMfaEnterPasscodeFormSchema = () =>
  yup.object().shape({
    passcode: yup
      .string()
      .stripAllWhitespace()
      .required()
      .max(fieldMaxLengths.passcode)
      .min(fieldMinLengths.passcode)
      .numeric()
      .label(i18n("MfaEnterPasscodeForm__PASSCODE").toLowerCase()),
  });
